import { invoiceStatuses, type InvoiceStatus } from 'src/constants/taxonomy';

const payableInvoiceStatuses: InvoiceStatus[] = [
  invoiceStatuses.DUE,
  invoiceStatuses.PARTIAL_PAYMENT,
];
const invoiceHistoryStatuses: InvoiceStatus[] = [
  invoiceStatuses.PENDING,
  invoiceStatuses.PAID,
  invoiceStatuses.NOT_APPLICABLE,
  invoiceStatuses.UNCLAIM,
  invoiceStatuses.UNCOLLECT,
  invoiceStatuses.COLLECTFEE,
];

export const showInvoiceInPayable = ({
  invoiceStatus,
}: {
  invoiceStatus: InvoiceStatus;
}): boolean => payableInvoiceStatuses.includes(invoiceStatus);

export const showInvoiceInHistory = ({
  invoiceStatus,
}: {
  invoiceStatus: InvoiceStatus;
}): boolean => invoiceHistoryStatuses.includes(invoiceStatus);
